import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { defineComponent, toRefs, computed } from "@vue/composition-api";
import Badge from "@Shared/components/general/badge.vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { parseSyncStatus } from "@Broker/js/custom/utils";
const {
  useGetters: useApplicationStoreGetters
} = createNamespacedHelpers("ApplicationStore");
export default defineComponent({
  name: "ApplicationSyncStatusBadge",
  components: {
    Badge
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const {
      applicationId
    } = toRefs(props);
    const {
      APPLICATION_SYNC_STATUS
    } = useApplicationStoreGetters([ApplicationGetters.APPLICATION_SYNC_STATUS]);
    const status = computed(() => {
      return parseSyncStatus(APPLICATION_SYNC_STATUS.value(applicationId.value), {
        error: {
          showDealId: false
        }
      });
    });
    const isSyncErrorStatus = computed(() => {
      var _context;
      return _includesInstanceProperty(_context = ["not-synced", "unable-to-sync"]).call(_context, status.value.code);
    });
    const isSyncLoadingStatus = computed(() => status.value.code === "syncing");
    return {
      status,
      isSyncErrorStatus,
      isSyncLoadingStatus
    };
  }
});